module.exports = __webpack_public_path__ + "img/indisponibilite.date.ee46c302.png";